import { useTranslation } from 'react-i18next';
import { changeLanguage } from './config';
import type { SupportedLanguage } from './config';

/**
 * Dil değiştirme bileşeni - Header'lara eklenir
 * Aktif dile göre bayrak ve kısaltma gösterir
 */
export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const currentLang = (i18n.language || 'tr') as SupportedLanguage;

  const toggleLanguage = () => {
    const newLang: SupportedLanguage = currentLang === 'tr' ? 'en' : 'tr';
    changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 px-2.5 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
      title={currentLang === 'tr' ? 'Switch to English' : 'Türkçe\'ye geç'}
    >
      {currentLang === 'tr' ? (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 800" className="w-5 h-3.5 rounded-sm flex-shrink-0">
            <rect width="1200" height="800" fill="#E30A17"/>
            <circle cx="425" cy="400" r="200" fill="#fff"/>
            <circle cx="475" cy="400" r="160" fill="#E30A17"/>
            <polygon fill="#fff" points="583,400 530,424 540,374 504,344 555,340 583,295 611,340 662,344 626,374 636,424"/>
          </svg>
          <span className="hidden sm:inline">TR</span>
        </>
      ) : (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30" className="w-5 h-3.5 rounded-sm flex-shrink-0">
            <clipPath id="s"><path d="M0,0 v30 h60 v-30 z"/></clipPath>
            <clipPath id="t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath>
            <g clipPath="url(#s)">
              <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
              <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
              <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#t)" stroke="#C8102E" strokeWidth="4"/>
              <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
              <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
            </g>
          </svg>
          <span className="hidden sm:inline">EN</span>
        </>
      )}
    </button>
  );
}
